/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S6_Bddk_LabelInputs */

const tr_mesafeli_s6_bddk_label = /** @type {(inputs: Mesafeli_S6_Bddk_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ödeme Şekli:`)
};

const en_mesafeli_s6_bddk_label = /** @type {(inputs: Mesafeli_S6_Bddk_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payment method:`)
};

const de_mesafeli_s6_bddk_label = /** @type {(inputs: Mesafeli_S6_Bddk_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zahlungsweise:`)
};

const ru_mesafeli_s6_bddk_label = /** @type {(inputs: Mesafeli_S6_Bddk_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Способ оплаты:`)
};

/**
* | output |
* | --- |
* | "Payment method:" |
*
* @param {Mesafeli_S6_Bddk_LabelInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s6_bddk_label = /** @type {((inputs?: Mesafeli_S6_Bddk_LabelInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S6_Bddk_LabelInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s6_bddk_label(inputs)
	if (locale === "de") return de_mesafeli_s6_bddk_label(inputs)
	if (locale === "ru") return ru_mesafeli_s6_bddk_label(inputs)
	return tr_mesafeli_s6_bddk_label(inputs)
});